import styled from 'styled-components'
import { greyGradient } from '../../lib/colors'
import { BOARD_STYLED_PROPS } from './interface'

//SCOREBOARD BACKGROUND
export const SeperateBorder = styled.div`
  background: linear-gradient(
    90deg,
    rgba(61, 65, 81, 0) 0%,
    rgb(61, 65, 81) 20%,
    rgb(61, 65, 81) 80%,
    rgba(61, 65, 81, 0) 100%
  );
  position: absolute;
  width: 59px;
  height: 5px;
  z-index: 2;
  right: 42%;
  top: 6.2px;
  transform: translateZ(300px);
`

export const Panel = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    0deg,
    rgba(28, 28, 33, 1) 0%,
    rgba(43, 44, 58, 1) 100%
  );
  transform: translateZ(100px) perspective(10px) rotateX(1deg);
  border-radius: 16px;
`
export const RollBorder = styled.div<BOARD_STYLED_PROPS>`
  position: absolute;
  left: 0.5px;
  top: -4px;
  width: 59%;
  height: 95%;
  z-index: -1;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  transform: translateZ(10px) perspective(6.5px) rotateX(1deg);
  background: ${({ deg, background }) =>
    background === 'blue'
      ? `linear-gradient(${deg}deg,rgba(61, 65, 81, 0.8981967787114846) 4%,rgba(61, 65, 81, 1) 6.73%,rgba(61, 65, 81, 1) 9.94%,rgba(61, 65, 81, 1) 15.26%,rgba(61, 65, 81, 1) 33.7%,rgba(61, 65, 81, 1) 69%,rgba(53,90,238,1) 82.72%,rgba(53,90,238,1) 98.02%);`
      : background === 'red'
      ? `linear-gradient(
  ${deg}deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(238, 57, 57, 1) 82.72%,
  rgba(238, 57, 57, 1) 98.02%
);`
      : greyGradient};
`

export const ResultBorder = styled.div<BOARD_STYLED_PROPS>`
  position: absolute;
  right: 0.5px;
  top: -4px;
  width: 59%;
  height: 95%;
  transform: translateZ(10px) perspective(6.5px) rotateX(1deg);
  background: ${({ background, deg }) =>
    background === 'green'
      ? `linear-gradient(
  ${deg}deg,
  rgba(61, 65, 81, 0.8981967787114846) 4%,
  rgba(61, 65, 81, 1) 6.73%,
  rgba(61, 65, 81, 1) 9.94%,
  rgba(61, 65, 81, 1) 15.26%,
  rgba(61, 65, 81, 1) 33.7%,
  rgba(61, 65, 81, 1) 69%,
  rgba(114, 173, 39, 1) 82.72%,
  rgba(114, 173, 39, 1) 98.02%
);`
      : greyGradient};
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
`
//SCORE BOARD

export const BoardWrapper = styled.div`
  width: 100%;
  height: 141px;
  position: relative;
  width: 314px;
  z-index: 1;
`

export const Board = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 2;
  padding: 30px;
  display: flex;
  flex-direction: column;
  transform: translateZ(200px);
`
export const InfoWrapper = styled.div``
